import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import { loadHubSpotVideoApi } from '../utils/loadPlayerApi'; // @ts-expect-error Not converted yet

import withPauseAndHelpLogic from '../higherOrderComponents/withPauseAndHelpLogic';

function getHsVideoApi() {
  return window.hsVideoApi;
}

class HubSpotVideoPlayer extends PureComponent {
  constructor(...args) {
    super(...args);
    this.containerRef = /*#__PURE__*/createRef();
    this.playerRef = /*#__PURE__*/createRef();

    this.initVideoPlayer = () => {
      this.playerRef.current = getHsVideoApi().renderPlayer(this.containerRef.current, this.buildOptionsFromProps());

      if (this.playerRef.current) {
        this.bindVideoEvents();
      } else {
        console.warn('renderPlayer did not return a player instance, cannot bind events');
      }
    };

    this.bindVideoEvents = () => {
      const {
        onPlay,
        onPause,
        onFinish,
        onReady,
        onUpdateProgress,
        onProgress
      } = this.props;

      if (onReady) {
        this.playerRef.current.on('ready', onReady);
      }

      if (onPlay) {
        this.playerRef.current.on('play', onPlay);
      }

      if (onPause) {
        this.playerRef.current.on('pause', onPause);
      }

      if (onFinish) {
        this.playerRef.current.on('ended', onFinish);
      }

      if (onUpdateProgress || onProgress) {
        if (onUpdateProgress) this.playerRef.current.on('progress', onUpdateProgress);else if (onProgress) this.playerRef.current.on('progress', onProgress);
      }
    };
  }

  componentDidMount() {
    loadHubSpotVideoApi().then(this.initVideoPlayer).catch(err => console.error(err));
  }

  componentDidUpdate(prevProps) {
    const {
      videoId,
      currentTime,
      playbackRate
    } = this.props;

    if (prevProps.videoId !== videoId) {
      getHsVideoApi().updatePlayer(this.playerRef.current.id, this.buildOptionsFromProps());
    }

    if (typeof currentTime === 'number' && prevProps.currentTime !== currentTime) {
      this.playerRef.current.postMessageToPlayer('SET_CURRENT_TIME', currentTime);
    }

    if (typeof playbackRate === 'number' && prevProps.playbackRate !== playbackRate) {
      this.playerRef.current.postMessageToPlayer('SET_PLAYBACK_RATE', playbackRate);
    }
  }

  buildOptionsFromProps() {
    const {
      env,
      region,
      portalId,
      playerType,
      renderContext,
      autoPlay,
      hiddenControls,
      maxHeight,
      objectFit,
      playbackRate
    } = this.props;
    return {
      id: this.props.videoId,
      env,
      region,
      portalId,
      playerType,
      renderContext,
      autoPlay,
      hiddenControls,
      maxHeight,
      objectFit,
      playButtonColor: this.props.color,
      muted: this.props.mutedByDefault,
      playbackRate
    };
  }

  render() {
    return /*#__PURE__*/_jsx("div", {
      className: "hubspot-video-player",
      ref: this.containerRef // prevent responsive sizing preventing clicks below video
      ,
      style: {
        overflow: 'hidden'
      }
    });
  }

}

HubSpotVideoPlayer.propTypes = {
  videoId: PropTypes.number.isRequired
};
HubSpotVideoPlayer.defaultProps = {
  env: 'prod',
  portalId: 53,
  playerType: 'academy',
  renderContext: 'ui-addon-video-player'
};
export default withPauseAndHelpLogic(HubSpotVideoPlayer);